import { createContext } from 'react'

import { AppAbility } from '@/lib/auth/casl'

export const AbilityContext = createContext({} as AppAbility)
